module.exports = __webpack_public_path__ + "static/img/qpcr_3.0dbb460.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qpcr_3.png
// module id = A+Ku
// module chunks = 16